export default __webpack_public_path__ + "static/media/hills2.2e0645a1.svg";